import EditSchema from './EditSchema.jsx';
import { ObjectTypes } from '../../lib/ObjectTypes.js';

const ManageFieldSchemas = ({}) => {
    return (
        <div className="max-w-2xl">
            <div className="mb-6 text-gray-500">
                Create fields that can be associated with each of your clients
                and appointments. Once you create a field, you will be able to
                add it’s value for each customer in their profile, or each
                appointment under Calendar.
            </div>
            <div className="panel-label">Client Fields</div>
            <EditSchema
                type={ObjectTypes.CLIENT}
                typeName="Client"
                className="mb-6"
            />

            <div className="panel-label">Event Fields</div>
            <EditSchema
                type={ObjectTypes.BOOKING_EVENT}
                typeName="Event"
                className="mb-6"
            />

            <div className="panel-label">Person/Bookable Things Fields</div>
            <EditSchema
                type={ObjectTypes.BOOKABLE_RESOURCE}
                typeName="Person/Resource"
                className="mb-6"
            />

            <div className="panel-label">
                Private Fields on Form Submissions
            </div>
            <EditSchema
                type={ObjectTypes.FORM_SUBMISSION}
                typeName="Form Submission"
                className="mb-6"
            />

            <div className="panel-label">Class Fields</div>
            <EditSchema
                type={ObjectTypes.CLASS}
                typeName="Class"
                className="mb-6"
            />
        </div>
    );
};

export default ManageFieldSchemas;
